import React, {Component} from 'react';
import '../styles/App.css';
import 'bootstrap/dist/css/bootstrap.css';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import {Route, Switch, HashRouter} from 'react-router-dom';
import MenuNavContainer from './MenuNavContainer.js';
import Toolbar from './Toolbar.js';
import About from './About.js';
import Team from './Team.js';
import Home from './Home.js';
import Products from './Products.js';
import SummaryTable from "./SummaryTable";
import Vineyard from "./AOCs/Vineyard";

class App extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="App">
                <Toolbar/>
                <HashRouter>
                    <MenuNavContainer>
                        <Switch>
                            <Route exact path="/" component={Home}/>
                            <Route exact path="/products" component={Products}/>
                            <Route exact path="/vineyards" component={SummaryTable}/>
                            <Route path="/vineyards/:id" component={Vineyard}/>
                            <Route exact path="/about" component={About}/>
                            <Route exact path="/about/team" component={Team}/>
                        </Switch>
                    </MenuNavContainer>
                </HashRouter>
            </div>
        );
    }
}

export default App;
